module.exports = __webpack_public_path__ + "img/light_line.4c2edd56.png";